import React from 'react';
import './GlassButton.css';

const GlassButton = ({ children, icon, onClick, className = '', style = {} }) => {
  return (
    <button 
      className={`glass-button ${className}`}
      onClick={onClick}
      style={style}
    >
      <div className="button-content">
        {icon && <span className="button-icon">{icon}</span>}
        <span className="button-text">{children}</span>
      </div>
      <div className="button-glow"></div>
      <div className="button-border"></div>
    </button>
  );
};

export default GlassButton;
